/**
 * RMFF Expandable Containers Widget TypeScript
 */
function initExpandableContainers() {
    var expandableWidgets = document.querySelectorAll('.rmff-expandable-containers-widget');
    expandableWidgets.forEach(function (widget) {
        var items = widget.querySelectorAll('.rmff-expandable-item');
        items.forEach(function (item) {
            var trigger = item.querySelector('.rmff-expandable-trigger');
            var content = item.querySelector('.rmff-expandable-content');
            var icon = item.querySelector('.rmff-expandable-icon svg');
            if (trigger && content && icon) {
                // Set initial state - all items collapsed
                content.style.maxHeight = '0px';
                content.style.opacity = '0';
                trigger.setAttribute('aria-expanded', 'false');
                // Add click event listener
                trigger.addEventListener('click', function () {
                    var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
                    if (isExpanded) {
                        // If item is expanded, collapse it
                        collapseItem(item, trigger, content, icon);
                    }
                    else {
                        // If item is collapsed, collapse all others first, then expand this one
                        collapseAllItems(items);
                        expandItem(item, trigger, content, icon);
                    }
                });
                // Add keyboard support for accessibility
                trigger.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        trigger.click();
                    }
                });
            }
        });
    });
}
function expandItem(item, trigger, content, icon) {
    // Expand the item
    content.classList.add('expanded');
    // Set the actual height for smooth animation
    var contentHeight = content.scrollHeight;
    content.style.maxHeight = contentHeight + 'px';
    content.style.opacity = '1';
    trigger.setAttribute('aria-expanded', 'true');
    // Change icon to minus
    icon.innerHTML = "\n        <path d=\"M5 12H19\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    ";
    // Add expanded class for styling
    item.classList.add('expanded');
}
function collapseItem(item, trigger, content, icon) {
    // Collapse the item
    content.style.maxHeight = '0px';
    content.style.opacity = '0';
    content.classList.remove('expanded');
    trigger.setAttribute('aria-expanded', 'false');
    // Change icon back to plus
    icon.innerHTML = "\n        <path d=\"M12 5V19M5 12H19\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    ";
    // Remove expanded class
    item.classList.remove('expanded');
}
function collapseAllItems(items) {
    items.forEach(function (item) {
        var trigger = item.querySelector('.rmff-expandable-trigger');
        var content = item.querySelector('.rmff-expandable-content');
        var icon = item.querySelector('.rmff-expandable-icon svg');
        if (trigger && content && icon) {
            collapseItem(item, trigger, content, icon);
        }
    });
}
// Export for use in index.ts
export { initExpandableContainers };
